import { API, Auth } from 'aws-amplify'

const GET_ADMIN_USERS = async function() {
  let apiName = 'ecobanka'
  let path = '/users'
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}

const DELETE_USER = async function(userId) {
  let apiName = 'ecobanka'
  let path = '/users/' + userId
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.del(apiName, path, myInit)
}

const POST_RESET_USER_PASSWORD = async function(userId) {
  let apiName = 'ecobanka'
  let path = `/users/${userId}/reset-password`
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const GET_USER_DETAILS = async function(userId) {
  let apiName = 'ecobanka'
  let path = '/users/' + userId
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}


const GET_MY_DETAILS = async function() {
  let apiName = 'ecobanka'
  let path = '/my-details' 
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}

const GET_USER_REQUESTS = async function(userId) {
  let apiName = 'ecobanka'
  let path = '/users/' + userId + '/requests'
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}

const GET_USER_SUB_USERS = async function(userId) {
  let apiName = 'ecobanka'
  let path = '/users/' + userId + '/sub-users'
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}

const PUT_UPDATE_USER = async function(payload) {
  let apiName = 'ecobanka'
  let path = `/users/${payload.userId}`
  let myInit = {
    body: {
      data: payload.data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.put(apiName, path, myInit)
}

const POST_NEW_USER = async function(data) {
  let apiName = 'ecobanka'
  let path = '/users'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_PRE_CREATE_PARTNER = async function(data) {
  let apiName = 'ecobanka'
  let path = '/partners'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

export {
  GET_ADMIN_USERS,
  DELETE_USER,
  POST_NEW_USER,
  GET_USER_DETAILS,
  GET_USER_REQUESTS,
  GET_USER_SUB_USERS,
  GET_MY_DETAILS,
  PUT_UPDATE_USER,
  POST_PRE_CREATE_PARTNER,
  POST_RESET_USER_PASSWORD
}
